import { createApp } from 'vue';
import App from "./App.vue";
import AppWC from "./AppWC.vue";
import router from "./router";
import store from '@/store';
import configUtils from '@/store/configUtils';


/** COOKIES **/
import VueCookies from 'vue3-cookies'

import oneUtils from "../gcdm-one-library/gcdm-one-utils/src/bootstrap";

const env = process.env.NODE_ENV;
console.log('[process.env.NODE_ENV]: ',process.env.NODE_ENV);
const appFolder = window.location.href.includes('/oneidtest') ? process.env.VUE_APP_PUBLIC_PATH.replace('/oneid', `/oneid/${process.env.VUE_APP_BLUE_TARGET_PREFIX}`) : process.env.VUE_APP_PUBLIC_PATH;
const configPath = window.location.href.includes('/oneidtest') ? process.env.VUE_APP_CONFIG_PATH.replace('/oneid', `/oneid/${process.env.VUE_APP_BLUE_TARGET_PREFIX}`) : process.env.VUE_APP_CONFIG_PATH;
console.log('configPath: ',configPath);
oneUtils.httpClient.init(router,env,appFolder,configPath, store);
oneUtils.trackingUtils.init(store);
oneUtils.utils.init(store);



import OneHead from "../gcdm-one-library/gcdm-one-head/src/OneHead.vue";
import OneSelect from "../gcdm-one-library/gcdm-one-select/src/OneSelect.vue";
import OneInput from "../gcdm-one-library/gcdm-one-input/src/OneInput.vue";
import OneButton from "../gcdm-one-library/gcdm-one-button/src/OneButton.vue";
import OneAlert from "../gcdm-one-library/gcdm-one-alert/src/OneAlert.vue";
import OneLanguageSelection from "../gcdm-one-library/gcdm-one-language-selection/src/OneLanguageSelection.vue";



/**
 * triggers navigation without losing the configurations parameters in query string
 * @param pathName
 */
const navigateByPath = function (pathName: string, params = {}) {
  
let currentParams = oneUtils.utils.getQueryParams();
delete currentParams.register_first;
delete currentParams.permanent;
delete currentParams.token;
delete currentParams.preRegistrationToken;
  router.push({
    path: pathName,
    query: { ...currentParams, ...params },
  });

  store.dispatch('setupOriginalUrl',window.location.href);

  /* uncomment for keep only configuration prams */
  // const query = {};
  // if (router.currentRoute.query.client)
  //   query["client"] = router.currentRoute.query.client;
  // if (router.currentRoute.query.language)
  //   query["language"] = router.currentRoute.query.language;
  // if (router.currentRoute.query.country)
  //   query["country"] = router.currentRoute.query.country;
  // if (router.currentRoute.query.brand)
  //   query["brand"] = router.currentRoute.query.brand;
  // router.push({ path: pathName, query: query });
};
const $configAssets =
  (window.location.href.includes('/oneidtest') ? process.env.VUE_APP_EXTERNAL_ASSETS_FOLDER.replace('/oneid', `/oneid/${process.env.VUE_APP_BLUE_TARGET_PREFIX}`) : process.env.VUE_APP_EXTERNAL_ASSETS_FOLDER)
  || "~@/assets/";
/**
 * builds the correct path based on external base path and relative ${requestedSource} path.
 * if no requestedSource provided, returns ""
 * @param requestedSource
 */
const assetSource = (requestedSource): string =>{
  return requestedSource ? `${$configAssets}${requestedSource}` : "";
};
const customToUpperCase = function (value: string){
  let upperCaseValue = '';
  try{
    upperCaseValue = value.toLocaleUpperCase(store.getters.getConfigurationParams.language);
  }catch(e){
    upperCaseValue = value.toUpperCase();
  }
  return upperCaseValue;
}


const basePath =
  process.env.VUE_APP_PUBLIC_PATH;


window.onpageshow = function(event) {
  if (event.persisted) {
      window.location.reload() 
  }
};


const el = document.getElementsByTagName('v-profile');
const isWC = !!el[0];
console.log('[One Profile Log] <v-profile>detected: ', isWC);

if(isWC){
  const getUserInfo = (e)=>{
    oneUtils.httpClient
    .getUserInfo(e.detail.oneid_access_token)
    .then((res) => {
      
      if (res) {
        console.log('[One Profile Log] customer success');

        const app = createApp(AppWC);

        app.component('OneInput', OneInput);
        app.component('OneSelect', OneSelect)
        app.component('OneHead', OneHead);
        app.component('OneButton', OneButton);
        app.component('OneAlert', OneAlert);
        app.component('OneLanguageSelection', OneLanguageSelection);

        app
        .provide('basePath',basePath)
        .provide('assetSource', assetSource)
        .provide('$navigateByPath', navigateByPath)
        .provide('$t', store.getters.translate)
        .provide('$c', store.getters.configure)
        .provide('brandClass', store.getters.brandClass)
        .provide('$toUpperCase', customToUpperCase)          
        .use(store)
        .use(VueCookies)
        .mount('#wc');
      
      } else {
        console.log('[One Profile Log] customer success with empty response');
      }
      oneUtils.utils.hideLeftLoader();
    })
    .catch((err) => {
      console.log('[One Profile Log] customer error:',err);
      oneUtils.utils.hideLeftLoader();
    });
  };
  const startWebcomponentWithEpaas = (e)=>{
    let currentParams = oneUtils.utils.getQueryParams();
    if(currentParams.epaas_consenttoken){
      const epaas = window['epaas'];
      const initObj ={
        tenant: store.getters.configure('_tenant_id'), 
        locale: store.getters.configure('_tenant_locale')
      }
      initObj['consentToken']=currentParams.epaas_consenttoken;
      ((window['epaas'] && window['epaas'].api) || window).addEventListener('consentcontroller.api.initialized', ()=>{
        epaasInitialized = true;
        getUserInfo(e);
      });
      epaas.api.initialize(initObj)
    }else{
      epaasInitialized = true;
      getUserInfo(e);  
    }
  };
  el[0].id="wc";


  window.addEventListener("WEB_COMPONENT_ACCESS_TOKEN", (e: any)=>{
    console.log('[One Profile Log] new access token retreived: ', e.detail.oneid_access_token);
    // Vue.prototype.$startupwebcomponent.oneid_access_token=e.detail.oneid_access_token;
    window['$startupwebcomponent'].oneid_access_token = e.detail.oneid_access_token;

  });
  let epaasInitialized = false;

  // add an appropriate event listener
  window.addEventListener("WEB_COMPONENT_STARTUP", function(e:any) {

   

    const prevEl = document.getElementsByTagName('v-profile');
    prevEl[0].id="wc";
    console.log('[One Profile Log] startup detected');
    console.log('   oneid_language', e.detail.oneid_language);
    console.log('   oneid_country', e.detail.oneid_country);
    console.log('   oneid_brand', e.detail.oneid_brand);
    console.log('   oneid_client', e.detail.oneid_client);
    console.log('   oneid_access_token', e.detail.oneid_access_token);
    // Vue.prototype.$startupwebcomponent=e.detail; 
    window['$startupwebcomponent'] = e.detail;
    oneUtils.utils.showGlobalLoader();

    configUtils
    .setupConfigurations({
      language: e.detail.oneid_language,
      country: e.detail.oneid_country,
      brand: e.detail.oneid_brand,
      client: e.detail.oneid_client,
    })
    .then(() => {

      const areEpaasAndTracyEnabled = function(){
        const areEpaasAndTracyEnabledGlobal = store.getters.configure("enable_epaas_&_tracy_tracking_global");
        const areEpaasAndTracyEnabledClient = store.getters.configure("enable_epaas_&_tracy_tracking");
        if (areEpaasAndTracyEnabledGlobal && areEpaasAndTracyEnabledClient !== undefined) {
            return areEpaasAndTracyEnabledGlobal && areEpaasAndTracyEnabledClient;
        }
        return areEpaasAndTracyEnabledGlobal;
      }
      

      
      
      if(areEpaasAndTracyEnabled() && !epaasInitialized){

        startWebcomponentWithEpaas(e);

      }else{
        epaasInitialized = true;
        getUserInfo(e);
      }
    })
    .catch((err) => {
      oneUtils.utils.hideLeftLoader();
      console.log('[One Profile Log] setup configuration error:',err);
    });
    
  });

}else{
  const app = createApp(App);
  app.component('OneInput', OneInput);
  app.component('OneSelect', OneSelect);
  app.component('OneHead', OneHead);
  app.component('OneButton', OneButton);
  app.component('OneAlert', OneAlert);
  app.component('OneLanguageSelection', OneLanguageSelection);
  
  app
  .provide('basePath',basePath)
  .provide('assetSource',assetSource)
  .provide('$navigateByPath', navigateByPath)
  .provide('$t', store.getters.translate)
  .provide('$c', store.getters.configure)
  .provide('brandClass', store.getters.brandClass)
  .provide('$toUpperCase', customToUpperCase)          
  .use(store)
  .use(VueCookies)
  .use(router)
  .mount('#vueapp');
}





